import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { KnownBusinessEntity } from "@/models/known-business-entity.model.ts"

export const useKnownBusinessEntityStore = defineStore("knownBusinessEntityStore", () => {
  const knownBusinessEntities: Ref<KnownBusinessEntity[]> = ref([])

  return {
    knownBusinessEntities
  }
})
